import { render, staticRenderFns } from "./PostSearchTotalResult.vue?vue&type=template&id=6ffe95ad&scoped=true&"
import script from "./PostSearchTotalResult.vue?vue&type=script&lang=js&"
export * from "./PostSearchTotalResult.vue?vue&type=script&lang=js&"
import style0 from "./PostSearchTotalResult.vue?vue&type=style&index=0&id=6ffe95ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe95ad",
  null
  
)

export default component.exports